/* eslint-disable camelcase */
import emojiData from "emoji-datasource";

import { anyWordStartsWith } from "../../../foundation/utils/string";

function fromUnifiedCodePoint(unifiedCodePoint: string): string {
    return String.fromCodePoint(...unifiedCodePoint.split("-").map(cp => Number.parseInt(cp, 16)));
}

function findDefaultEmojiWithShortName(shortName: string): typeof emojiData[number] | undefined {
    return emojiData.find(({ short_names }) => short_names.includes(shortName));
}

function getDefaultSuggestedEmojis(text: string): { alias: string; emoji: typeof emojiData[number]; }[] {
    const suggestedEmojis = [];

    for (const emoji of emojiData) {
        for (const short_name of emoji.short_names) {
            if (short_name.startsWith(text) || anyWordStartsWith(short_name, text)) {
                suggestedEmojis.push({
                    alias: short_name,
                    emoji
                });
            }
        }
    }

    return suggestedEmojis;
}

export default {
    fromUnifiedCodePoint,
    findDefaultEmojiWithShortName,
    getDefaultSuggestedEmojis
};
